import React from 'react';
import styles from './Banner.module.scss';
import { Color } from '../../lib/types';
import { Button } from '../Button/Button';

interface IProps {
  bgColor?: Color;
  headline: string;
  text?: string;
  btnText: string;
  btnLink: string;
  className?: string
}

export const Banner = ({bgColor = 'marina-blue', headline, text, btnText, btnLink, className}: IProps): React.JSX.Element => {
  
  return (
    <section className={`${styles.banner} bg-color--${bgColor} ${className ||''}`}>
      <div className={styles.designElement}></div>
      <div className={`grid-12 ${styles.container}`}>
        <div className={styles.content}>
          <h2 className='headline__h2 color--white'>
            { headline }
          </h2>
          {
            !!text && 
            <p className='color--white'>{ text }</p>
          }
        </div>

        <div className={styles.btnWrap}>
          <Button 
            className='bg-color--daylight-blue color--white'
            path={btnLink} 
            size='lg'
          >
            { btnText }
          </Button>
        </div>
      </div>
    </section>
  )
}